class CommunityComponent extends HTMLElement {
	constructor() {
		super();
		this.elements = null;
	}

	connectedCallback() {
		this.init();
		this.bindYearClicks();
		this.ensureInitialActiveYear();
		this.updateAll();
	}

	init() {
		this.elements = {
			wrapper: this.querySelector(".main-community__donation-wrapper"),
			years: this.querySelectorAll(".main-community__donation-wrapper-year-item"),
			items: this.querySelectorAll(".main-community__donation-item"),
			allTimeTotal: this.querySelector(".js-alltime-total"),
			allTimeTotalMobile: this.querySelector(".js-alltime-total-mobile"),
			yearTitle: this.querySelector(".js-year-title"),
			yearTotal: this.querySelector(".js-year-total"),
		};

		this.templates = {
			allTime:
				this.elements.wrapper?.getAttribute("data-alltime-template") || "[total] ALL-TIME",
			yearTitle:
				this.elements.wrapper?.getAttribute("data-year-title-template") ||
				"Our [year] Donations",
			yearTotal:
				this.elements.wrapper?.getAttribute("data-yeartotal-template") ||
				"[total] YEAR TO DATE",
		};
	}

	bindYearClicks() {
		this.elements.years.forEach((yearEl) => {
			yearEl.addEventListener("click", (e) => {
				e.preventDefault();
				const year = yearEl.getAttribute("data-year");
				this.setActiveYear(year);
				this.filterItemsByYear(year);
				this.updateYearTotals(year);
			});
		});
	}

	ensureInitialActiveYear() {
		const hasActive = Array.from(this.elements.years).some((y) =>
			y.classList.contains("active")
		);
		if (!hasActive && this.elements.years.length) {
			this.elements.years[0].classList.add("active");
			this.filterItemsByYear(this.elements.years[0].getAttribute("data-year"));
		} else {
			const active = this.querySelector(".main-community__donation-wrapper-year-item.active");
			if (active) {
				this.filterItemsByYear(active.getAttribute("data-year"));
			}
		}
	}

	updateAll() {
		const activeYear = this.getActiveYear();
		this.updateAllTimeTotals();
		if (activeYear) this.updateYearTotals(activeYear);
	}

	getActiveYear() {
		return this.querySelector(
			".main-community__donation-wrapper-year-item.active"
		)?.getAttribute("data-year");
	}

	setActiveYear(year) {
		this.elements.years.forEach((y) => y.classList.remove("active"));
		const toActivate = Array.from(this.elements.years).find(
			(y) => y.getAttribute("data-year") === year
		);
		if (toActivate) toActivate.classList.add("active");
	}

	filterItemsByYear(year) {
		this.elements.items.forEach((item) => {
			item.style.display = item.getAttribute("data-accept-year") === year ? "block" : "none";
		});
	}

	parseAmountFromItem(itemEl) {
		const data = itemEl.getAttribute("data-amount");
		if (data && !isNaN(data)) return Number(data);

		// Fallback: đọc từ DOM p bên trong (nếu bạn giữ nguyên)
		const p = itemEl.querySelector(".main-community__donation-item-block-total p");
		const raw = p ? p.textContent : "0";
		return this.parseMoney(raw);
	}

	parseMoney(str) {
		if (!str) return 0;
		const num = String(str).replace(/[^0-9.\-]/g, "");
		const val = Number(num);
		return isNaN(val) ? 0 : val;
	}

	formatCurrency(n) {
		return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
	}

	sumAllItems() {
		let total = 0;
		this.elements.items.forEach((item) => {
			total += this.parseAmountFromItem(item);
		});
		return total;
	}

	sumItemsByYear(year) {
		let total = 0;
		this.elements.items.forEach((item) => {
			if (item.getAttribute("data-accept-year") === year) {
				total += this.parseAmountFromItem(item);
			}
		});
		return total;
	}

	applyTemplate(tpl, map) {
		let out = tpl;
		Object.keys(map).forEach((k) => {
			out = out.replaceAll(`[${k}]`, map[k]);
		});
		return out;
	}

	updateAllTimeTotals() {
		const total = this.sumAllItems();

		const prettyNumber = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
			total
		);
		const text = this.applyTemplate(this.templates.allTime, { total: prettyNumber });

		if (this.elements.allTimeTotal) this.elements.allTimeTotal.textContent = text;
		if (this.elements.allTimeTotalMobile) this.elements.allTimeTotalMobile.textContent = text;
	}

	updateYearTotals(year) {
		const total = this.sumItemsByYear(year);

		const title = this.applyTemplate(this.templates.yearTitle, { year });

		const totalText = this.applyTemplate(this.templates.yearTotal, {
			total: this.formatCurrency(total),
			year,
		});

		if (this.elements.yearTitle) this.elements.yearTitle.textContent = title;
		if (this.elements.yearTotal) this.elements.yearTotal.textContent = totalText;
	}
}

customElements.define("community-component", CommunityComponent);
